import { styled } from "@mui/material/styles";
import { DialogContent, DialogContentText, Grid } from "@mui/material";

export const Container = styled(Grid)({
  width: "100%",
  height: "100%",
});

export const Content = styled(DialogContent)({
  borderTop: "1px solid lightgrey",
  borderBottom: "1px solid lightgrey",
});

export const ContentText = styled(DialogContentText)({
  padding: "20px 0 0",
});
